import React, { useState, useEffect } from 'react';
import BasePage from '../components/BasePage';
import Fields from '../components/Fields';
import Image from '../components/Image';
import DocumentButton from '../components/Buttons/DocumentButton';
import { format } from 'date-fns';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import { useLocation, useNavigate } from 'react-router-dom';
import { MessageCircleQuestion, BookA, Wrench  } from 'lucide-react';


const SuiviClient = (props) => {

    const navigate = useNavigate()

    const content = (data) => {
        console.log("Données récupérées :", data); 
        // Utilisez la variable data récupérée dans BasePage ici
        // Par exemple, vous pouvez afficher les données ou effectuer toute autre logique avec elles
        if (!data) {
            return false;
        }

        return (
            <div id="suiviclient" className="p-6">
               
                {data ? (
                    <>
                        <div className="grid grid-cols-2 grid-rows-2 gap-4 p-4 mb-10">
                            <div className="mt-8 ">
                                <Link to="https://wiki.meosis.fr/" target="_blank" className="bg-mlime text-lg px-6 py-4 rounded-3xl w-full max-w-lg flex items-center justify-center text-white font-bold block text-center m-auto">
                                    Prendre rendez-vous avec le suivi client
                                </Link>
                            </div>
                        </div>

                    </>
                ) : (
                    // Sinon, affiche un message de chargement ou d'erreur
                    <p>Chargement en cours...</p>
                )}
            </div>
        );
    };

    return <BasePage content={content} title={props.title ?? 'Suivi Client'} />;
};

export default SuiviClient;
